// Funciones utilitarias compartidas entre componentes

// URL base del API
export const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Color único para cada miembro del equipo
export const getAvatarColor = (index) => {
  const colors = [
    'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    'linear-gradient(135deg, #374151 0%, #374151 100%)',
    'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
    'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
    'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
    'linear-gradient(135deg, #84cc16 0%, #65a30d 100%)',
    'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
  ];
  return colors[index % colors.length];
};

// Color fijo por cargo/rol del miembro de equipo (mismo cargo = mismo color siempre,
// sin importar el orden en que aparezca en la tabla). Claves normalizadas en minúscula
// para tolerar variaciones de mayúsculas entre distintos orígenes de datos.
const CARGO_COLORS = {
  'gerente de proyecto': 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
  'administrador': 'linear-gradient(135deg, #111827 0%, #374151 100%)',
  'jefe de terreno': 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
  'supervisor': 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
  'calidad': 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
  'administrador de obra': 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
  'oficina tecnica': 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  'jefe de oficina tecnica': 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
  'jefe de bodega': 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
  'oficina central': 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
};
const CARGO_COLORS_FALLBACK = [
  'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
  'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
  'linear-gradient(135deg, #84cc16 0%, #65a30d 100%)',
];

// Devuelve siempre el mismo color para un mismo cargo. Si el cargo no está en
// CARGO_COLORS (ej. un cargo personalizado), se asigna un color determinístico
// del fallback en base al texto del cargo, en vez de uno aleatorio o por índice.
export const getCargoColor = (cargo) => {
  if (!cargo) return '#6b7280';
  const key = cargo.trim().toLowerCase();
  if (CARGO_COLORS[key]) return CARGO_COLORS[key];
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return CARGO_COLORS_FALLBACK[hash % CARGO_COLORS_FALLBACK.length];
};

// Formatear fecha a formato chileno dd/mm/yyyy
export const formatDate = (date) => {
  if (!date) return '';
  let fechaNormalizada;
  if (typeof date === 'string' && date.includes('-') && !date.includes('T')) {
    const [year, month, day] = date.split('-').map(num => parseInt(num));
    fechaNormalizada = new Date(year, month - 1, day);
  } else {
    fechaNormalizada = new Date(date);
  }
  return fechaNormalizada.toLocaleDateString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

// Normalizar string de fecha a objeto Date sin problemas de timezone
export const normalizarFecha = (fechaString) => {
  if (typeof fechaString === 'string' && fechaString.includes('-') && !fechaString.includes('T')) {
    const [year, month, day] = fechaString.split('-').map(num => parseInt(num));
    return new Date(year, month - 1, day);
  }
  return new Date(fechaString);
};

// Formatear números con separadores de miles (puntos)
export const formatearPrecio = (valor) => {
  if (!valor) return '';
  const numero = valor.toString().replace(/\D/g, '');
  return numero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

// Manejar cambio en inputs de precio (limpia caracteres no numéricos)
export const handlePrecioChange = (valor, setter) => {
  const valorLimpio = valor.replace(/\D/g, '');
  setter(valorLimpio);
};
